import { Button, type ButtonProps } from '@neo/primitives/button'
import { Loader2, Play } from 'lucide-react'
import { useFlowStore } from '../../store'
import { useStartEval } from './hooks/use-start-eval'
import { useEvalStore } from './store'

interface EvalButtonProps extends Omit<ButtonProps, 'onClick' | 'loading'> {}

// Component to start a fresh eval (always clears existing data)
export const StartEvalButton = ({ variant = 'ghost', size = 'xs', ...props }: EvalButtonProps) => {
  const startEval = useStartEval()

  return (
    <Button
      variant={variant}
      size={size}
      typography="action"
      type="button"
      onClick={() => startEval()}
      data-testid="button-start-eval"
      {...props}
    >
      <Play className="h-4 w-4 mr-2" />
      Start simulated test
    </Button>
  )
}

// Component to view eval results (only shows sidebar)
export const ViewResultsButton = ({
  variant = 'ghost',
  size = 'xs',
  ...props
}: EvalButtonProps) => {
  const isEvalRunning = useEvalStore((state) => state.isEvalRunning)
  const showEvalSidebar = useFlowStore((state) => state.setShowEvalSidebar)

  const handleViewResults = () => {
    showEvalSidebar(true)
  }

  return (
    <Button
      variant={variant}
      size={size}
      typography="action"
      type="button"
      onClick={handleViewResults}
      data-testid="button-view-results"
      {...props}
    >
      {isEvalRunning && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
      View latest results
    </Button>
  )
}
